<template>
  <section class="event-view">
    <div class="header">YOUR EVENTS</div>
    <events-overview/>
  </section>
</template>

<script>
  import EventsOverview from '@/components/EventsPage/EventsOverview'

  export default {
    components: {
      EventsOverview,
    }
  }
  
</script>

<style scoped>
html {
  background: #efefef;
  height: 100%;
}
.event-view {
  padding-bottom: 20px;
}
.header {
  margin: 30px auto;
  max-width: 1152px;
  font-size: 36px;
  font-weight: 900;
  color: #707070;
  display: flex;
}
</style>

